import "react";
import { styled as e } from "styled-components";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/Toolbar/Toolbar.tsx
var r = e.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme: e }) => e.spacing(1.5, 3)};
    background-color: ${({ theme: e }) => e.colors.card};
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.lg};
    gap: ${({ theme: e }) => e.spacing(2)};
`, i = e.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(2)};
    flex: 1;
    min-width: 0;
`, a = e.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    flex-shrink: 0;
`, o = ({ searchSlot: e, actions: o, className: s }) => /* @__PURE__ */ n(r, {
	className: s,
	children: [/* @__PURE__ */ t(i, { children: e }), /* @__PURE__ */ t(a, { children: o })]
});
//#endregion
export { o as Toolbar };
